<script>
import { connect } from 'vuex-connect';
import KeyboardBox from '../scenes/KeyboardBox.vue';

export default connect({
  actionsToEvents: {
    input: 'updateSearch',
  },
  stateToProps: {
    value: state => state.launcher.search,
  },
})('KeyboardBox', KeyboardBox);
</script>
